import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-logo",
  templateUrl: "./logo.component.html",
  styleUrls: ["./logo.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent implements OnInit {
  @Input() orientation = "right";


  ngOnInit() {
    const isValidOrientation = ["right", "left", "top", "bottom"].includes(this.orientation);
    if (!isValidOrientation) {
      throw new Error(`The orientation cannot be ${this.orientation}`);
    }
  }
}
